import React from 'react'
import PropTypes from 'prop-types'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './RefreshIcon.scss'
const rootClassName = 'refresh-icon'

export const RefreshIcon = (props) => {
  return (
    <svg
      className={getMergedClassNames([
        rootClassName,
        props.animate ? 'animate' : ''
      ])}
      viewBox='0 0 24 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.35247 2.87297C8.11024 3.00526 7.80639 2.91658 7.67381 2.67491C7.54122 2.43323 7.6301 2.13007 7.87233 1.99779C11.3937 0.0747083 15.7659 0.724249 18.5715 3.58577C20.5542 5.59283 21.4943 8.88918 21.1171 11.861L23.132 9.67507C23.3189 9.47227 23.6352 9.45906 23.8385 9.64555C24.0417 9.83205 24.055 10.1476 23.868 10.3504L20.573 13.9253C20.3862 14.1279 20.0718 14.1403 19.8696 13.9575C19.8616 13.9503 19.8538 13.9429 19.8463 13.9352L17.2904 11.3852C17.0952 11.1903 17.0952 10.8745 17.2904 10.6797C17.4857 10.4849 17.8023 10.4849 17.9976 10.6797L19.9617 12.6394C20.6462 9.75895 19.8201 6.27113 17.858 4.28479C15.3645 1.74162 11.4806 1.16463 8.35247 2.87297ZM15.9721 17.1516C16.2152 17.0209 16.5185 17.1115 16.6495 17.354C16.7806 17.5965 16.6898 17.8991 16.4467 18.0298C12.9446 19.9137 8.61685 19.2656 5.82236 16.4394C3.79251 14.3854 2.80264 11.0138 3.19781 8.02724L0.853504 10.3655C0.658215 10.5603 0.341632 10.5603 0.146397 10.3654C-0.0488376 10.1706 -0.0487934 9.85474 0.146496 9.65995L3.71703 6.09856C3.84829 5.95777 4.05544 5.89977 4.24892 5.96749C4.33892 5.99899 4.41419 6.05357 4.4704 6.12224L7.05295 8.9227C7.23992 9.12544 7.22676 9.44103 7.02355 9.62758C6.82033 9.81412 6.50402 9.80099 6.31705 9.59824L4.31833 7.43088C3.67778 10.2724 4.5605 13.7415 6.53434 15.7388C9.01673 18.2493 12.8612 18.8251 15.9721 17.1516Z'
      />
    </svg>
  )
}

RefreshIcon.propTypes = {
  animate: PropTypes.bool
}

RefreshIcon.defaultProps = {
  animate: true
}
